import {twMerge} from '@sdox/utils'

import {EufePages} from '../../Detail/EufePages'
import {ThemeProvider} from '../../ThemeProvider'

import type {DocumentQuery} from '@sdox/api'

interface DocumentTypeContentProps {
  data: Extract<DocumentQuery['document'], {__typename: 'DocumentType'}>
}

export const DocumentTypeContent = ({data}: DocumentTypeContentProps) => (
  <div className={'max-w-section @container/section'}>
    <div
      className={twMerge(
        'my-spacing-12 @block-large:mb-spacing-24 @block-large:mt-spacing-32',
        '[--radius-section:0] @block-large:[--radius-section:var(--radius-lg)]',
        '[--gap-section:12px] @block-large:[--gap-section:32px]',
      )}
    >
      <ThemeProvider
        xcTheme={data.xcTheme}
        className={'contents'}
      >
        <EufePages
          pages={data.pages}
          inlineDisclaimers={data.inlineDisclaimers}
          externalLinkDisclaimerConfig={data.externalLinkDisclaimerConfig}
        />
      </ThemeProvider>
    </div>
  </div>
)
